"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.createVanillaDisclaimerBox = createVanillaDisclaimerBox;
exports["default"] = DisclaimerBox;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _themeProvider = require("@mmc/theme-provider");
var _commonRichText = require("@mmc/common-rich-text");
var _tippy = _interopRequireWildcard(require("tippy.js"));
var _closeButtonIcon_black = _interopRequireDefault(require("./close-button-icon_black"));
var _iconArrow_white = require("./icon-arrow_white");
var _disclaimerBox = _interopRequireDefault(require("./disclaimer-box.css"));
var _getPercentageOfPixel = _interopRequireDefault(require("./utils/getPercentageOfPixel"));
var _getPositionClass = _interopRequireDefault(require("./utils/getPositionClass"));
var _CloseButtonIconBlack;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var initTooltip = function initTooltip(_ref) {
  var _Fragment;
  var buttonEl = _ref.buttonEl,
    text = _ref.text,
    theme = _ref.theme,
    tooltipPlacement = _ref.tooltipPlacement;
  var CloseButton = function CloseButton() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _disclaimerBox["default"].closeButton,
      role: "button",
      onClick: _tippy.hideAll,
      onKeyPress: function onKeyPress(e) {
        return e.key === 'Enter' && (0, _tippy.hideAll)();
      },
      tabIndex: "-1"
    }, _CloseButtonIconBlack || (_CloseButtonIconBlack = /*#__PURE__*/_react["default"].createElement(_closeButtonIcon_black["default"], null)));
  };
  var getIconArrowByPlacement = function getIconArrowByPlacement(placement) {
    switch (placement) {
      case 'bottom':
        return _iconArrow_white.IconArrowTop;
      case 'right':
        return _iconArrow_white.IconArrowLeft;
      default:
        return null;
    }
  };
  (0, _tippy["default"])(buttonEl, {
    content: function content() {
      var newEl = document.createElement('div');
      _reactDom["default"].render(_Fragment || (_Fragment = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(CloseButton, null), /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        html: text,
        theme: theme
      }))), newEl);
      return newEl;
    },
    arrow: getIconArrowByPlacement(tooltipPlacement),
    trigger: 'click',
    placement: tooltipPlacement,
    interactive: true,
    maxWidth: 320,
    allowHTML: true,
    duration: [0, 0],
    popperOptions: {
      strategy: 'fixed'
    },
    appendTo: document.body
  });
};
function DisclaimerBox(_ref2) {
  var disclaimer = _ref2.disclaimer,
    disclaimerId = _ref2.disclaimerId,
    disclamerText = _ref2.disclamerText,
    textFontSize = _ref2.textFontSize,
    textFontFamily = _ref2.textFontFamily,
    disclaimerButtonSpacing = _ref2.disclaimerButtonSpacing,
    tooltipPlacement = _ref2.tooltipPlacement,
    setDisclaimerFontSizePrcnt = _ref2.setDisclaimerFontSizePrcnt;
  var theme = (0, _themeProvider.useTheme)();
  var buttonRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    initTooltip({
      buttonEl: buttonRef.current,
      text: disclamerText,
      theme: theme,
      textFontSize: textFontSize,
      tooltipPlacement: tooltipPlacement
    });
    var buttonFontSize = (0, _getPercentageOfPixel["default"])(setDisclaimerFontSizePrcnt, {
      fontSize: window.getComputedStyle(buttonRef.current.parentElement.parentElement).fontSize
    });
    buttonRef.current.style.fontSize = buttonFontSize;
  }, []);
  var buttonFontSize = (0, _react.useMemo)(function () {
    return (0, _getPercentageOfPixel["default"])(setDisclaimerFontSizePrcnt, {
      fontSize: textFontSize
    });
  }, [textFontSize]);
  var positionClass = (0, _react.useMemo)(function () {
    return (0, _getPositionClass["default"])({
      fontFamily: textFontFamily,
      styles: _disclaimerBox["default"]
    });
  }, [textFontSize]);
  var disclaimerClick = function disclaimerClick(e) {
    e.preventDefault();
  };
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: _disclaimerBox["default"].wrapper + " " + positionClass,
    style: disclaimerButtonSpacing ? {
      transform: "translate(" + disclaimerButtonSpacing + ")"
    } : {}
  }, disclaimer, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick(e) {
      return disclaimerClick(e);
    },
    ref: buttonRef,
    className: "" + _disclaimerBox["default"].button,
    tabIndex: "-1",
    type: "button",
    style: {
      fontSize: buttonFontSize
    }
  }, disclaimerId));
}
DisclaimerBox.defaultProps = {
  tooltipPlacement: 'bottom'
};

/**
 * Needed in components that render raw html like the RichText component
 */
function createVanillaDisclaimerBox(_ref3) {
  var disclaimer = _ref3.disclaimer,
    disclaimerId = _ref3.disclaimerId,
    _ref3$disclamerText = _ref3.disclamerText,
    disclamerText = _ref3$disclamerText === void 0 ? '' : _ref3$disclamerText,
    theme = _ref3.theme,
    textFontSize = _ref3.textFontSize,
    _ref3$extraClass = _ref3.extraClass,
    extraClass = _ref3$extraClass === void 0 ? '' : _ref3$extraClass,
    tooltipPlacement = _ref3.tooltipPlacement,
    setDisclaimerFontSizePrcnt = _ref3.setDisclaimerFontSizePrcnt;
  var buttonId = typeof document !== 'undefined' ? "disclaimerBox_button_" + disclaimerId + "_" + Math.random() : 'no_button_id';
  var initialize = function initialize() {
    setTimeout(function () {
      var buttonEl = document.getElementById(buttonId);
      var buttonFontSize = (0, _getPercentageOfPixel["default"])(setDisclaimerFontSizePrcnt, {
        fontSize: window.getComputedStyle(buttonEl.parentElement.parentElement).fontSize
      });
      buttonEl.style.fontSize = buttonFontSize;
      initTooltip({
        buttonEl: buttonEl,
        text: disclamerText,
        theme: theme,
        tooltipPlacement: tooltipPlacement
      });
    }, 0);
  };
  var buttonFontSize = (0, _getPercentageOfPixel["default"])(setDisclaimerFontSizePrcnt, {
    fontSize: textFontSize
  });
  var component = "\n  <span class='" + _disclaimerBox["default"].wrapper + " " + _disclaimerBox["default"].htmlDisclaimer + " " + (extraClass || _disclaimerBox["default"].extraClass) + "'>\n  " + disclaimer + "<button id='" + buttonId + "' class='" + _disclaimerBox["default"].button + "' type=\"button\" style='font-size: " + buttonFontSize + ";'>\n      " + disclaimerId + "\n    </button>\n  </span>";
  return {
    component: component,
    initialize: initialize
  };
}